import React, { useState, useEffect } from 'react'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import {
  GetReportReq,
  GetCheckListReq,
  DefectItem,
} from 'features/report/auditRoad/types'

import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'

import { getReport, getCheckList } from 'features/report/auditRoad/api'
import { resetDefect, updateDefect } from 'features/report/auditRoad/actions'
import {
  selectEvent,
  selectEventChecklist,
} from 'features/report/auditRoad/selector'
import { selectEvent as selectUnitEvent } from 'features/masterData/selector'

import EventModal from 'Components/Shared/Modal/EventModal'

import ReportInfo from '../ReportInfo'
import DefectDetail from '../DefectDetail'
import DefectView from '../DefectView'

type Props = {
  title: string
  initPage?: string
  ProjectCode: string
  RequestID: number
  CheckNumber: number
  onPage?: (name: string) => void
  isApprove?: boolean
  readOnly?: boolean
  addMode?: boolean
  isShowEditImg?: boolean
  isShowCorrectImg?: boolean
  refresh?: number
} & ReduxProps

const AuditRoadReport: React.ComponentType<Props> = props => {
  const [page, setPage] = useState('')
  const [enableModal, setEnableModal] = useState(false)
  const dispatch = useDispatch()

  const {
    Token,
    UserEmail,
    event,
    eventChecklist,
    unitEvent,

    initPage = '',
    title,
    ProjectCode,
    RequestID,
    CheckNumber,
    onPage = (name: string) => {},
    isShowEditImg = false,
    isShowCorrectImg = false,
    readOnly = false,
    isApprove = false,
    addMode = true,
    refresh = 0,
  } = props

  useEffect(() => {
    setPage(initPage)
    setEnableModal(false)
  }, [initPage])

  useEffect(() => {
    const req: GetCheckListReq = {
      ProjectCode,
      UserEmail,
    }

    dispatch(getCheckList(Token, req))
  }, [ProjectCode])

  useEffect(() => {
    getPlanReport()
  }, [ProjectCode, CheckNumber, RequestID, refresh])

  const getPlanReport = () => {
    const req: GetReportReq = {
      ProjectCode,
      UserEmail,
      CheckNumber,
      RequestID,
    }

    dispatch(getReport(Token, req))
  }

  const onAdd = () => {
    const name = 'add.defect'
    setPage(name)
    onPage(name)
    dispatch(resetDefect())
  }

  const onEdit = (item: DefectItem) => {
    const name =
      addMode && item.CheckNumber === CheckNumber
        ? 'edit.defect'
        : 'view.defect'
    setPage(name)
    onPage(name)
    dispatch(updateDefect(item))
  }

  const onClose = () => {
    setPage('')
    onPage('')
  }

  const onCompeted = () => {
    setPage('')
    onPage('')
    getPlanReport()
  }

  switch (page) {
    case 'add.defect':
    case 'edit.defect':
      return (
        <DefectDetail
          ProjectCode={ProjectCode}
          RequestID={RequestID}
          onClose={onClose}
          addMode={page === 'add.defect'}
          onCompeted={onCompeted}
        />
      )
    case 'view.defect':
      return (
        <DefectView
          ProjectCode={ProjectCode}
          RequestID={RequestID}
          readOnly={readOnly}
          isApprove={isApprove}
          onClose={onClose}
          onCompeted={onCompeted}
        />
      )
    default:
      return (
        <>
          <EventModal
            event={[event, unitEvent, eventChecklist]}
            enable={enableModal}
            errorCalback={() => setEnableModal(false)}
          />
          <ReportInfo
            title={title}
            onAdd={addMode && readOnly === false ? onAdd : undefined}
            onEdit={onEdit}
            isShowEditImg={isShowEditImg}
            isShowCorrectImg={isShowCorrectImg}
          />
        </>
      )
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    Token: serviceTokenSelector(state),
    UserEmail: userEmailSelector(state),
    event: selectEvent(state),
    eventChecklist: selectEventChecklist(state),
    unitEvent: selectUnitEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuditRoadReport)
